<template>
    <div class="d-inline-flex" v-if="deviceData.state != null">
        <v-switch
            v-model="deviceData.state.value"
            inset
            dense
            hide-details
            class="pa-0"
            @click="changeDeviceState"
            :loading="loading"
            :disabled="loading || deviceData.disabled"
            color="#FF8484"
        ></v-switch>
    </div>
</template>

<script>
import { LOADING_TIMEOUT } from "@/utils/constants.js";
export default {
    name: "DeviceSwitchEnable",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        }
    },
    data() {
        return {
            deviceData: {},
            loading: false,
            disabledTimeout: null,
        };
    },
    created() {
        this.deviceData = this.device;
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
    },
    methods: {
        changeDeviceState() {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.loading = false;
                this.deviceData.state.value = this.deviceData.state ? !this.deviceData.state.value : null;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/hotel-admin/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state ? this.deviceData.state.value : null
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.deviceData.state.value = this.deviceData.state ? !this.deviceData.state.value : null;
                    this.loading = false;
                    console.log(error);
                });
        },
    },
}
</script>